import { render } from "./Vedio.vue?vue&type=template&id=c7482276&scoped=true&lang=pug"
import script from "./Vedio.vue?vue&type=script&lang=js"
export * from "./Vedio.vue?vue&type=script&lang=js"

import "./Vedio.vue?vue&type=style&index=0&id=c7482276&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7482276"]])

export default __exports__